import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import {
  DropdownFilter,
  FloatInput,
  FloatSelect,
  HeadPage,
} from "src/componentes";
import TributacaoCfopCadastroCode from "./TributacaoCfopCadastro.Code";
import { useNavigate } from "react-router-dom";
import { CategoriasCadastroDto } from "src/pages/Privada/Estoque/Categorias/Cadastro/CategoriasCadastro.Dto";
import { useUrlTabModule } from "src/hook/useUrlTab.Module";

const TributacaoCfopCadastroView = () => {
  const code = TributacaoCfopCadastroCode();
  const navigate = useNavigate();
  const tab = useUrlTabModule("tab", "tabDados");

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar =
    (id: number, tributacaocfopid: number, type: number) => () => {
      if (type === 4) {
        navigate(
          `/fiscal/tributacao/cfop/imposto/ibscbs/cadastro?id=${id}&type=${type}&tributacaocfopid=${tributacaocfopid}`,
        );
      } else {
        navigate(
          `/fiscal/tributacao/cfop/imposto/cadastro?id=${id}&type=${type}&tributacaocfopid=${tributacaocfopid}`,
        );
      }
    };

  return (
    <Container>
      <Form noValidate onSubmit={code.form.handleSubmit(code.onSubmit)}>
        <HeadPage headText="Cadastro Cfop">
          {code.menuItens !== undefined &&
            code.menuItens.map((item) => (
              <Dropdown.Item
                key={item.name}
                onClick={handleClickNavigate(item.route)}
              >
                {item.name}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!code.loading ? (
          <Tabs defaultActiveKey={tab.value} onSelect={tab.set}>
            <Tab eventKey="tabDados" title="Dados">
              <>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatInput
                        registerField={code.form.register("cfop")}
                        label="CFOP"
                        errorsMessage={code.form.formState.errors.cfop}
                        inputMask="int"
                        maxLength={4}
                        tooltipMessage="Código CFOP com 4 números, duvidas consulte seu contador."
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <FloatSelect
                      label="Tipo Parâmetro"
                      options={code.getOptions()}
                      register={code.form.register("tipoParametro")}
                      errorsMessage={code.form.formState.errors.tipoParametro}
                      tooltipMessage="Parametrize impostos, crie gatilhos diferentes para gerar inteligência em sua grade tributária."
                      onSelect={(value: string | number) =>
                        code.setSelectedParametroValor(String(value))
                      }
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    {(() => {
                      switch (code.selectedParametroValor) {
                        case "1":
                          return (
                            <DropdownFilter<CategoriasCadastroDto>
                              fetchData={
                                code.consultarCategoria.CategoriaBuscar
                              }
                              loading={code.consultarCategoria.loading}
                              labelDescription="Categoria"
                              getDescription={(item: CategoriasCadastroDto) =>
                                item.nome
                              }
                              getId={(item: CategoriasCadastroDto) => item.id}
                              registeredFields={{
                                id: code.form.register("parametroValor"),
                                description:
                                  code.form.register("categoriaNome"),
                              }}
                              errorsMessageDescription={
                                code.form.formState.errors.parametroValor
                              }
                              onSelect={(
                                item: CategoriasCadastroDto | undefined,
                              ) => {
                                if (item !== undefined) {
                                  code.form.setValue("parametroValor", item.id);
                                  code.form.setValue(
                                    "categoriaNome",
                                    item.nome,
                                  );
                                } else {
                                  code.form.setValue("categoriaNome", "");
                                }
                              }}
                            ></DropdownFilter>
                          );
                        case "2":
                          return <div>Exibindo conteúdo para a opção 2</div>;
                        case "3":
                          return (
                            <FloatInput
                              registerField={code.form.register(
                                "parametroValor",
                              )}
                              label="Parâmetro Valor"
                              errorsMessage={
                                code.form.formState.errors.parametroValor
                              }
                              inputMask="int"
                              maxLength={4}
                              tooltipMessage="Conforme o tipo do parâmetro configurado digite o valor que o parâmetro será aplicado ao gatilho."
                            />
                          );
                      }
                    })()}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <FloatSelect
                      label="Mensagem"
                      options={code.getMensagemOptions()}
                      register={code.form.register("mensagemId")}
                      errorsMessage={code.form.formState.errors.mensagemId}
                      tooltipMessage="Vincule uma mensagem fiscal para este CFOP (opcional)."
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="d-grid mt-3 mb-5">
                    <Button type="submit">Confirmar</Button>
                  </Col>
                </Row>
              </>
            </Tab>
            {!code.incluir && (
              <Tab eventKey="tabImpostos" title="Impostos">
                {code.data && code.data.length > 0 ? (
                  (() => {
                    const temClassTrib = code.data.some((item) => !!item.classificacoesTributarias);
                    return (
                      <Table responsive striped hover>
                        <thead>
                          <tr>
                            <th className={temClassTrib ? "col-4" : "col-6"}>Imposto</th>
                            <th className={temClassTrib ? "col-4" : "col-6"}>CSOSN/CST</th>
                            {temClassTrib && <th className="col-4">Class. Tributária</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {code.data?.map((item) => (
                            <tr
                              key={item.id}
                              onClick={handleClickAlterar(
                                item.id,
                                item.tributacaoCFOPId,
                                item.tipoImposto,
                              )}
                              style={{ cursor: "pointer" }}
                            >
                              <td className={temClassTrib ? "col-4" : "col-6"}>{item.tipoImpostoDescricao}</td>
                              <td className={temClassTrib ? "col-4" : "col-6"}>
                               {item.tipoImposto === 4
                                  ? String(item.cst).padStart(3, "0")
                                  : String(item.cst).padStart(2, "0")}
                              </td>
                              {temClassTrib && (
                                <td className="col-4">
                                  {item.classificacoesTributarias || "-"}
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    );
                  })()
                ) : (
                  <Form.Text>Sem Dados</Form.Text>
                )}
              </Tab>
            )}
          </Tabs>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default TributacaoCfopCadastroView;
